<template>
  <div class="layout" :class="{ isH5 }">
    <div class="layout-bg"></div>
    <div class="layout-content">
      <div class="layout-content-wrap">
        <p class="title">
          <slot name="title"></slot>
        </p>
        <slot name="main"></slot>
        <div class="btn-wrap">
          <slot name="button"></slot>
        </div>
      </div>
      <em
        class="layout-close j-close-terms"
        v-if="!isH5 && !hideClose"
        @click="handleClose"
      ></em>
    </div>
    <slot name="popup"></slot>
  </div>
</template>

<script>
import terms from '@mixins/terms/terms';

export default {
  name: 'Layout',
  mixins: [terms],
  methods: {
    handleClose() {
      if (this.isFromUserCenter) {
        this.$emit('closePopup');
      } else {
        this.closeTerms();
      }
    }
  },
  props: {
    isFromUserCenter: {
      type: Boolean,
      default: false
    },
    hideClose: {
      type: Boolean,
      default: false
    }
  }
};
</script>
